import React, { useState } from "react";
import Classes from "./Intake.module.css";
import MoreDropDown from "./MoreDropDown";
import { useNavigate } from "react-router-dom";

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

const Intake = () => {
    const navigateTo = useNavigate();
    const handleNavigate = (page) => {
        navigateTo(page);
    }

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <div className="flexAlign10" >
                    <input type="checkbox" />
                    <h5>Form</h5>
                </div>
                <button onClick={() => { handleNavigate('/add-intake-form') }} className={Classes.addBtn}>
                    <AddIcon height='12px' fill='white' />
                    <h5>Intake form</h5>
                </button>
            </div>
            <div className={Classes.body} >
                <div className={Classes.list} >
                    <div className="flexAlign10" >
                        <input type="checkbox" />
                        <h5 className={Classes.lightText} >Intake - John Smith</h5>
                    </div>
                    <MoreDropDown />
                </div>
                <div className={Classes.list} >
                    <div className="flexAlign10" >
                        <input type="checkbox" />
                        <h5 className={Classes.lightText} >Intake - John Smith</h5>
                    </div>
                    <MoreDropDown />
                </div>
                <div className={Classes.list} >
                    <div className="flexAlign10" >
                        <input type="checkbox" />
                        <h5 className={Classes.lightText} >Intake - John Smith</h5>
                    </div>
                    <MoreDropDown />
                </div>
                <div className={Classes.list} >
                    <div className="flexAlign10" >
                        <input type="checkbox" />
                        <h5 className={Classes.lightText} >Intake - John Smith</h5>
                    </div>
                    <MoreDropDown />
                </div>
                <div className={Classes.list} >
                    <div className="flexAlign10" >
                        <input type="checkbox" />
                        <h5 className={Classes.lightText} >Intake - John Smith</h5>
                    </div>
                    <MoreDropDown />
                </div>
            </div>
        </div>
    );
};

export default Intake;
